import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "light-green-text" }, "check_circle", -1)
const _hoisted_4 = { class: "max" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  class: "italic"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "orange-text" }, "clear", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_modal = _resolveComponent("tickets-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h6", null, [
          _createTextVNode(_toDisplayString($props.res.displayName()) + " ", 1),
          _createElementVNode("a", {
            class: "dash",
            href: `tel:${$props.res.phone}`
          }, _toDisplayString($props.res.phone), 9, _hoisted_5)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", null, _toDisplayString($props.res.display()), 1)
        ]),
        ($props.res.notes)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($props.res.notes), 1))
          : _createCommentVNode("", true)
      ]),
      ($props.viewProperties.canManageReservation($props.res.seatid))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "none",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.del($props.res)))
          }, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_tickets_modal, {
      ref: "modal",
      onOk: $setup.deleteRes
    }, null, 512)
  ], 64))
}